//import liraries
import React, { useEffect, useState } from "react";
import { Dimensions } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize,} from "rn-responsive-styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: 450,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginLeft: 20,
    },
    container: {
      marginTop: "2%",
      flexDirection: "row",
      paddingLeft: 30,
      paddingHorizontal: 50,
      marginLeft: 10,
    },
    backIcon: {
      height: 19,
      width: 19,
      resizeMode: "center",
      opacity: 0.8,
    },
    innerContainer: {
      flexDirection: "column",
      marginLeft: 20,
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
      marginLeft: 10,
    },
    firstContainer: {
      flexDirection: "row",
    },
    secondContainer: {
      flexDirection: "column",
      width: 300,
      marginTop: 10,
      marginLeft: 50,
    },
    containerBorder: {
      width: 320,
      height: 176,
      marginTop: 20,
      paddingHorizontal: 10,
      borderRadius: 10,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
    },
    cardContainer: {
      width: 260,
      height: 84,
      marginVertical: 17,
      marginLeft: 17,
      flexDirection: "row",
    },
    thirdContainer: {
      flexDirection: "column",
      marginLeft: 90,
    },
    radioButtonView: {
      flexDirection: "row",
      marginVertical: 25,
    },
    poolBalWidget:{
      flexDirection: "row",
      justifyContent: "space-between",
      marginVertical: 15,
    },
    debitTextStyle:{ 
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0,
      textAlign: "left",
      color: "#bbbbbb"
      },
    creditTo: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: 300,
      height: 40,
      paddingTop: 10,
      marginLeft: 50,
    },
    debitFrom: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginLeft: 20,
    },
    selectionContainerStyle: {
      flexDirection: "row",
      marginLeft: 50,
    },
    radiobuttonOutSideStyle: {
      width: 15,
      height: 15,
      borderRadius: 10,
      borderColor: "#9d1d27",
      borderWidth: 2,
      alignItems: "center",
      justifyContent: "center",
    },
    radioButtonInsideStyle: {
      height: 7,
      width: 7,
      borderRadius: 7,
      backgroundColor: "#9d1d27",
    },
    chooseOptionStyle: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0,
      textAlign: "left",
      color: "#797673",
    },
    selectTag: {
      flexDirection: "row",
      marginLeft: 50,
      width: 450,
      justifyContent: "space-between",
    },
    enterAmtBorder: {
      width: 220,
      height: 40,
      borderStyle: "solid",
      borderWidth: 2,
      borderRadius: 5,
      borderColor: "#dfdfdf",
      paddingHorizontal: 10,
      backgroundColor: "rgba(0, 0, 0, 0)",

      opacity: 0.4,
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 19.8,
      letterSpacing: 0.1,
      textAlign: "left",
      color: "#25243b",
    },
    selectView: {
      width: 243.6,
      height: 39.4,
      borderRadius: 5,
      color: "#b6b7bf",
      fontWeight: "bold",
      borderWidth: 2,
      borderColor: "#dfdfdf",
      borderStyle: "solid",
      alignItems: "flex-start",
      paddingHorizontal: 10,
      justifyContent: "center",
    },
    selectText: {
      opacity: 0.4,
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 19.8,
      letterSpacing: 0.1,
      textAlign: "left",
      color: "#25243b",
    },
    perVehicle: {
      fontSize: 11,
      fontWeight: "500",
      alignSelf: "flex-end",
      color: "#757575",
      marginVertical: 10,
    },
    customButtonView: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    buttonViewStyle: {
      width: 118,
      height: 31,
    },
    cardNUmberTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    poolAcTextStyle: {
      opacity: 0.6,
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 12,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    amountTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    customButtonViewStyle: {
      width: 218,
      height: 37,
      alignSelf: "flex-start",
      marginLeft: 70,
    },
  },
  {
    [DEVICE_SIZES.SM]: {
      mainContainer: {
        width: "100%",
        height: 700,
        marginBottom: 50,
        paddingBottom: 50,
      },
      firstContainer: {
        flexDirection: "column",
      },
      selectTag: {
        flexDirection: "column",
        width: 350,
        alignItems: "flex-start",
      },
      border: {
        marginVertical: 30,
      },
    },

    [DEVICE_SIZES.MD]: {
      mainContainer: {
        flexDirection: "column",
        width: "100%",
        height: 760,
      },
      firstContainer: {
        flexDirection: "column",
      },
      border: {
        marginVertical: 10,
      },
      thirdContainer: {
        marginLeft: 10,
      },
      selectTag: {
        flexDirection: "column",
      },
      enterAmtBorder: {
        marginTop: 20,
      },
      perVehicle: {
        alignSelf: "flex-start",
        paddingLeft: 50,
      },
      customButtonViewStyle: {
        alignSelf: "flex-end",
        marginRight: 30,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainer: {
        flexDirection: "column",
        width: "100%",
        height: 760,
        marginLeft: 0,
      },
      containerBorder: {
        width: 255,
        height: 159,
      },
      firstContainer: {
        flexDirection: "column",
      },
      border: {
        marginVertical: 10,
      },
      thirdContainer: {
        marginLeft: 10,
      },
      selectTag: {
        flexDirection: "column",
        width: 350,
        alignItems: "flex-start",
      },
      enterAmtBorder: {
        marginTop: 10,
      },
      perVehicle: {
        alignSelf: "flex-start",
        paddingLeft: 50,
      },
      customButtonViewStyle: {
        alignSelf: "flex-end",
        marginRight: 30,
        marginBottom: 10,
      },
      cardNUmberTextStyle: {
        fontSize: 11,
      },
      buttonViewStyle: {
        width: 99,
        height: 21,
      },
      poolAcTextStyle: {
        fontSize: 8,
      },
      amountTextStyle: {
        fontSize: 12,
      },
      creditTo: {
        width: "60%",
      },
      debitFrom: {
        width: "80%",
      },
    },
  }
);

//make this component available to the app
export default useStyles;
